module.exports = __webpack_public_path__ + "img/inu_main0.8e9ee075.jpg";